import uid from "common/utils/uid";
import type { DocEntityType } from "../doc/docEntityTypes";
import type { DocEntityBase } from "./docEntityBase";

export function docEntityBaseNew<T extends DocEntityType>(entityType: T, id = uid()): DocEntityBase<T> {
  return {
    id,
    name: "",
    entityType,
    sortIndex: 0,
  };
}
